import script from "./DepartmentManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentManagement.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentManagement.vue?vue&type=style&index=0&id=f47a88be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f47a88be"]])

export default __exports__